import React from 'react';
import { Container } from './ErrorContainer.styles';

const ErrorContainer = ({ errorText, className, twoLine, small }) => {
  return (
    <Container className={className} $twoLine={twoLine} $small={small}>
      {errorText}
    </Container>
  );
};

export default ErrorContainer;
